import { render, staticRenderFns } from "./CategoriaForm.vue?vue&type=template&id=c98cae96&scoped=true"
import script from "./CategoriaForm.vue?vue&type=script&lang=js"
export * from "./CategoriaForm.vue?vue&type=script&lang=js"
import style0 from "./CategoriaForm.vue?vue&type=style&index=0&id=c98cae96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c98cae96",
  null
  
)

export default component.exports